var _ellipse, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateOwners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 118,
    viewBox: "0 0 112 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.9996,
    cy: 62.5862,
    rx: 55.4136,
    ry: 55.4136,
    fill: "#EDEEF0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -32,
    y: -10,
    width: 156,
    height: 128
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.943436 56.2605L-8.79593 63.1723L-31.665 44.9943L-12.6074 -5.72826L36.0627 -9.24658L97.6334 -4.26229L123.728 27.1094L103.613 34.2207C108.567 42.5184 111.414 52.22 111.414 62.5864C111.414 93.1905 86.604 118 55.9999 118C25.3958 118 0.586308 93.1905 0.586308 62.5864C0.586308 60.4473 0.707516 58.3365 0.943436 56.2605Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3105 48.5814C71.1093 48.5814 82.2955 37.706 82.2955 24.2905C82.2955 10.8749 71.1093 -0.000488281 57.3105 -0.000488281C43.5116 -0.000488281 32.3255 10.8749 32.3255 24.2905C32.3255 37.706 43.5116 48.5814 57.3105 48.5814ZM16 101.5C16 79.9472 26.2662 61.4278 40.9499 53.3409C45.7904 56.0159 51.3702 57.5406 57.3105 57.5406C63.3278 57.5406 68.9752 55.9761 73.8589 53.2363C88.6446 61.2673 99 79.8538 99 101.5C99 130.495 80.4198 154 57.5 154C34.5802 154 16 130.495 16 101.5Z",
    fill: "#CACBCD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateOwners);
export default __webpack_public_path__ + "static/media/empty-state-owners.758ac145.svg";
export { ForwardRef as ReactComponent };